// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3j4X9","footer":"ReportModalFilter_footer__fb_M9"};